export default __webpack_public_path__ + "static/media/c001-fsi-4.574c4ff9.jpg";